module.exports = __webpack_public_path__ + "img/formats-2.b35260cf.png";